import React from "react";
import "../css/App.css"
import styles from "./Loader.module.css";

function Loader() {
  return (
    <div
      aria-busy="true"
      aria-label="Loading"
      role="progressbar"
      className={styles.container} // Use className instead of class
    >
      <div className={styles.swing}>
        <div className={styles["swing-l"]}></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div className={styles["swing-r"]}></div>
      </div>
      <div className={styles.shadow}>
        <div className={styles["shadow-l"]}></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div className={styles["shadow-r"]}></div>
      </div>
    </div>
  );
}

export default Loader;
